// components/BookingModal/FormRow.js
import React from 'react';
import styles from './styles.module.scss';

const FormRow = ({ 
  children, 
  className = '',
  gap = 'medium',
  alignItems = 'stretch',
  justifyContent = 'flex-start',
  wrap = true,
  ...props
}) => {
  const rowClass = `${styles.formRow} ${styles[`gap-${gap}`]} ${className}`;
  
  const style = {
    alignItems,
    justifyContent,
    flexWrap: wrap ? 'wrap' : 'nowrap'
  };

  return (
    <div className={rowClass} style={style} {...props}>
      {React.Children.map(children, (child, index) => (
        child ? (
          <div key={index} className={styles.formItem}>
            {child}
          </div>
        ) : null
      ))}
    </div>
  );
};

export default FormRow;